/* eslint-disable no-unused-vars */

function bodyBgUpdate() {
  // Select the target elements to observe
  const blueElement = document.querySelector(".bg-blue__wrapper");
  const tanElement = document.querySelector(".bg-tan__wrapper");
  const whiteElement = document.querySelector(".bg-white__wrapper");

  // Combine all target elements in an array
  const targets = [blueElement, tanElement, whiteElement].filter(Boolean);

  // Define the options for the Intersection Observer
  const options = {
    rootMargin: "0px",
    threshold: 0.1, // Adjust this value based on your needs
  };

  // Create the Intersection Observer to observe all target elements
  const observer = new IntersectionObserver(handleVisibilityChange, options);

  // Observe the target elements
  targets.forEach((target) => {
    observer.observe(target);
  });

  // Function to handle visibility change for all targets
    function handleVisibilityChange(entries) {
        // Variables to track visibility
        let isBlueVisible = false;
        let isTanVisible = false;
        let isWhiteVisible = false;

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (entry.target === blueElement) {
                    isBlueVisible = true;
                } else if (entry.target === tanElement) {
                    isTanVisible = true;
                } else if (entry.target === whiteElement) {
                    isWhiteVisible = true;
                }

                console.log(entry.target);
            }
        });

        // Priority based background change
        if (isBlueVisible) {
            document.body.style.backgroundColor = getComputedStyle(document.body).getPropertyValue("--color-mabel");
            console.log("blue");
        } else if (isTanVisible) {
            document.body.style.backgroundColor = getComputedStyle(document.body).getPropertyValue("--color-wildSand");
            console.log("tan");
        } else if (isWhiteVisible) {
            document.body.style.backgroundColor = getComputedStyle(document.body).getPropertyValue("--color-white");
            console.log("white");
        } else {
            document.body.style.backgroundColor = getComputedStyle(document.body).getPropertyValue("--color-body-bg");
            console.log("default");
        }
    }
}


/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    bodyBgUpdate();
};

export default init;
